export const mapStateConfig = {
    bearing: 18.84375,
    dragRotate: true,
    latitude: 39.25306643634273,
    longitude: 9.13240471337313,
    pitch: 6.693334238491111,
    zoom: 10,
    isSplit: false,
    minZoom: 9.5,
    maxZoom:16,
}